import React from 'react';
import { Input } from 'antd';
import { Field } from '@src/components/Common/Form';

/** An OpenAI assistant is reached by its own id rather than a model name. */
const OpenAIModelForm = () => (
    <>
        <Field
            name={['extra_data', 'OPENAI_API_KEY']}
            label="API key"
            span={6}
            rules={[{ required: true, message: 'Enter the API key' }]}
        >
            <Input.Password className="nf-mono" placeholder="Enter API key" visibilityToggle={false} autoComplete="off" />
        </Field>

        <Field
            name={['extra_data', 'OPENAI_ASSISTANT_ID']}
            label="Assistant ID"
            span={6}
            rules={[{ required: true, message: 'Enter the assistant ID' }]}
        >
            <Input className="nf-mono" placeholder="asst_…" />
        </Field>
    </>
);

export default OpenAIModelForm;
